import { render, staticRenderFns } from "./SiloSvg.vue?vue&type=template&id=3d19105d&"
import script from "./SiloSvg.vue?vue&type=script&lang=js&"
export * from "./SiloSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports